import React from 'react';
import {InferPropTypes} from 'commons/types/Types';
import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';
import InnerFormDashboardUsers from './InnerFormDashboardUsers';
import {DashboardUsersValues} from 'commons/models';
import {Messages} from 'commons/constants';

DashboardUsersForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    personKey: PropTypes.string,
};

const FormControl = withFormik<
    InferPropTypes<typeof DashboardUsersForm.propTypes>,
    DashboardUsersValues
>({
    mapPropsToErrors: () => {
        return {
            file: '',
            expedientId: '',
            kycFatherId: '',
            personKey: '',
        };
    },
    mapPropsToValues: (props) => {
        return {
            file: '',
            expedientId: 0,
            kycFatherId: 0,
            personKey: props.personKey ? props.personKey : '',
        };
    },
    validate: (values: DashboardUsersValues) => {
        const errors: FormikErrors<DashboardUsersValues> = {};
        if (!values.file) {
            errors.file = Messages.FILE_NOT_SELECTED;
        }
        return errors;
    },
    validateOnBlur: true,
    validateOnChange: true,
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler(values);
    },
})(InnerFormDashboardUsers);

function DashboardUsersForm(props: InferPropTypes<typeof DashboardUsersForm.propTypes>) {
    const {submitHandler, personKey} = props;

    return (
        <div className='DashboardUsersForm'>
            <FormControl
                // eslint-disable-next-line react/jsx-handler-names
                submitHandler={submitHandler}
                personKey={personKey}
            />
        </div>
    );
}
export default DashboardUsersForm;
